const angular = require('angular');

const DynamicContentService = require('./dynamic-content.service');
const DynamicContentCarouselService = require('./dynamic-content-carousel.service');
const DynamicContentScheduleKeyService = require('./dynamic-content-schedule-key.service');
const dynamicContentUrlScheduleDirectiveDefinition = require('./dynamic-content-url-schedule');
const dynamicContentGlobalScheduleDirectiveDefinition = require('./dynamic-content-global-schedule');
const manageDynamicContentDirectiveDefinition = require('./manage-dc.directive');
const dynamicContentDirectiveDefinition = require('./dynamic-content.directive');
const dynamicContentDialogDirectiveDefinition = require('./dynamic-content-dialog.directive');
const dynamicContentHideViewDirectiveDefinition = require('./dynamic-content-hide-viewed.directive');
const dynamicContentProductGroupDirectiveDefinition = require('./dynamic-content-product-group.directive');
const { dynamicContentProductGroupTileListComponentDefinition } = require('./dynamic-content-product-group-tile-list.component');
const dynamicContentItemDirectiveFactory = require('./dynamic-content-item.directive');

angular.module('wowApp.common')
    .factory('DynamicContentService', ['Restangular', DynamicContentService])
    .service('DynamicContentCarouselService', ['SettingsService', DynamicContentCarouselService])
    .service('DynamicContentScheduleKeyService', ['Settings', DynamicContentScheduleKeyService])
    .directive('olyDcUrlSchedule', ['$location', dynamicContentUrlScheduleDirectiveDefinition])
    .directive('olyDcGlobalSchedule', ['$location', 'DynamicContentScheduleKeyService', dynamicContentGlobalScheduleDirectiveDefinition])
    .directive('wowManageDc', [manageDynamicContentDirectiveDefinition])
    .directive('olyDynamicContent', ['TrolleyService', 'ShelfProductService', 'DynamicContentService', 'DynamicContentCarouselService', 'InspirationService', '$location', 'AnalyticsService', dynamicContentDirectiveDefinition])
    .directive('olyDcDialog', ['DynamicContentService', 'DialogRegistry', dynamicContentDialogDirectiveDefinition])
    .directive('olyDcHideViewed', [dynamicContentHideViewDirectiveDefinition])
    .directive('olyDcProductGroup', [dynamicContentProductGroupDirectiveDefinition])
    .component('olyDcProductGroupTileList', dynamicContentProductGroupTileListComponentDefinition)
    .directive('olyDynamicContentProduct', [dynamicContentItemDirectiveFactory('<wow-shelf-product-tile product="item" ng-if="item"></wow-shelf-product-tile>', 'Products')])
    .directive('olyDynamicContentRecipe', [dynamicContentItemDirectiveFactory('<wow-recipe-tile recipe="item" ng-if="item"></wow-recipe-tile>', 'Recipes')])
    .directive('olyDynamicContentCard', [dynamicContentItemDirectiveFactory('<wow-inspiration-tile card="item" ng-if="item"></wow-inspiration-tile>', 'Cards')])
    .run(['$templateCache', ($templateCache) => {
        const bootstrap = $('.dynamic-content-bootstrap');
        for (let i = 0; i < bootstrap.length; ++i) {
            const templateBootstrap = bootstrap[i];
            const scheduleKey = templateBootstrap.attributes['schedule-key'].value;
            const templateCacheKey = `/Shop/DynamicContent2Panel?scheduleKey=${scheduleKey}`;
            $templateCache.put(templateCacheKey, templateBootstrap.innerHTML);
        }
    }]);



// WEBPACK FOOTER //
// ./src/common/dynamiccontent/index.js